var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g({ref:_vm.data.ref,staticClass:"p-relative h-100"},_vm.listeners),[_c('div',{staticClass:"anchored scrollable",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }